import API from "../axios";
import APIV2 from "../iventas_api_v2";

export const getWaStatusAccount = async (providerId) => {
  try {
    const response = await API.get(
      `/broadcast/get360Status?providerId=${providerId}`
    );
    return response?.data;
  } catch (error) {
    console.log("ERROR_getWaStatusAccount", error);
    throw new Error("ERROR_getWaStatusAccount");
  }
};

export const getBroadcastPricing = async (
  channelId,
  templateId,
  tagsIds,
  conjunction
) => {
  try {
    const response = await API.post(`/broadcast/getTotalPricing`, {
      channelId,
      templateId,
      tagsIds,
      conjunction,
    });
    return response?.data;
  } catch (error) {
    console.log("ERROR_getBroadcastPricing", error);
    throw new Error("ERROR_getBroadcastPricing");
  }
};

export const createTemplate = async (companyId, channelId, templateData) => {
  try {
    if (!companyId) {
      throw new Error("COMPANY_ID_REQUIRED");
    }
    if (!channelId) {
      throw new Error("CHANNEL_ID_REQUIRED");
    }
    if (!templateData) {
      throw new Error("TEMPLATE_DATA_REQUIRED");
    }

    if (!templateData?.name) {
      throw new Error("TEMPLATE_NAME_REQUIRED");
    }
    if (!templateData?.category) {
      throw new Error("TEMPLATE_CATEGORY_REQUIRED");
    }

    if (!templateData?.text) {
      throw new Error("TEMPLATE_TEXT_REQUIRED");
    }

    const requestPayload = {
      template: {
        name: templateData?.name,
        category: templateData?.category,
        lang: templateData?.lang ?? "es",
        text: templateData?.text,
        type: templateData?.type || "TEXT",
        ...(templateData?.mediaUrl && { mediaUrl: templateData?.mediaUrl }),
        ...(templateData?.variables && { variables: templateData?.variables }),
        ...(templateData?.buttons && { buttons: templateData?.buttons }),
        ...(templateData?.footer && { footer: templateData?.footer }),
      },
    };

    const response = await APIV2.post(
      `/company/${companyId}/channel/${channelId}/templates`,
      requestPayload
    );

    return response?.data;
  } catch (error) {
    console.log("ERROR_createTemplate", error);

    if (error.response?.data?.error) {
      const apiError = error.response.data.error;
      switch (apiError) {
        case "ERROR_AT_CREATING_TEMPLATE":
          throw new Error("ERROR_AT_CREATING_TEMPLATE");
        case "INVALID_CHANNEL":
          throw new Error("INVALID_CHANNEL");
        case "AUTH_TOKEN_IS_REQUIRED":
          throw new Error("AUTH_TOKEN_IS_REQUIRED");
        case "AUTH_TOKEN_IS_INVALID":
          throw new Error("AUTH_TOKEN_IS_INVALID");
        default:
          throw new Error(`API_ERROR: ${apiError}`);
      }
    }

    if (error.response?.status === 403) {
      throw new Error("AUTHENTICATION_ERROR");
    }

    if (error.response?.status === 400) {
      throw new Error("BAD_REQUEST");
    }

    if (error.response?.status === 500) {
      const serverMessage =
        error.response?.data?.message || "Internal server error";
      throw new Error(`SERVER_ERROR: ${serverMessage}`);
    }

    if (
      error.message?.message?.endsWith(
        "que proporcionó ya está en uso. Elija un nombre diferente para su plantilla."
      )
    ) {
      throw new Error("TEMPLATE_NAME_ALREADY_EXISTS");
    }

    if (error.message && error.message?.includes("_REQUIRED")) {
      throw error;
    }

    throw new Error("ERROR_createTemplate");
  }
};

export const createBroadcast = async (broadcastData) => {
  try {
    if (!broadcastData) {
      throw new Error("BROADCAST_DATA_REQUIRED");
    }
    if (!broadcastData?.templateName) {
      throw new Error("TEMPLATE_NAME_REQUIRED");
    }
    if (
      !broadcastData?.leads ||
      !Array.isArray(broadcastData?.leads) ||
      broadcastData?.leads.length === 0
    ) {
      throw new Error("LEADS_REQUIRED");
    }
    if (!broadcastData?.token) {
      throw new Error("TOKEN_REQUIRED");
    }

    if (broadcastData?.actions) {
      if (!Array.isArray(broadcastData?.actions)) {
        throw new Error("ACTIONS_MUST_BE_ARRAY");
      }
    }

    if (broadcastData?.sendAt) {
      const sendAtDate = new Date(broadcastData?.sendAt);
      if (isNaN(sendAtDate.getTime())) {
        throw new Error("INVALID_SEND_AT_FORMAT");
      }
    }

    const requestPayload = {
      templateName: broadcastData?.templateName,
      leads: broadcastData?.leads.map((lead) => ({
        phone: lead.phone,
        ...(lead.vars && { vars: lead.vars }),
      })),
      token: broadcastData?.token,
      ...(broadcastData?.fileUrl && { fileUrl: broadcastData?.fileUrl }),
      ...(broadcastData?.name && { name: broadcastData?.name }),
      ...(broadcastData?.sendAt && { sendAt: broadcastData?.sendAt }),
      ...(broadcastData?.actions && { actions: broadcastData?.actions }),
      ...(broadcastData?.phonesToNotify && { phonesToNotify: broadcastData?.phonesToNotify }),
      ...(broadcastData?.tagId && { tagId: broadcastData?.tagId }),
    };

    const response = await APIV2.post("/broadcast", requestPayload);

    return response?.data;
  } catch (error) {
    console.log("ERROR_createBroadcast", error);

    if (error.response?.data?.error) {
      const apiError = error.response.data.error;
      switch (apiError) {
        case "INVALID_CHANNEL_TOKEN":
          throw new Error("INVALID_CHANNEL_TOKEN");
        case "TEMPLATE_NOT_FOUND":
          throw new Error("TEMPLATE_NOT_FOUND");
        case "INVALID_NUMBER_OF_VARIABLES":
          throw new Error("INVALID_NUMBER_OF_VARIABLES");
        case "ERROR_SENDING_TEMPLATE_WITH_VARIABLES":
          const serverMessage =
            error.response?.data?.message ||
            "Error sending template with variables";
          throw new Error(
            `ERROR_SENDING_TEMPLATE_WITH_VARIABLES: ${serverMessage}`
          );
        default:
          throw new Error(`API_ERROR: ${apiError}`);
      }
    }

    if (error.response?.status === 400) {
      const errorMessage = error.response?.data?.message || "Bad request";
      throw new Error(`BAD_REQUEST: ${errorMessage}`);
    }
    if (error.response?.status === 403) {
      throw new Error("AUTHENTICATION_ERROR");
    }
    if (error.response?.status === 500) {
      const serverMessage =
        error.response?.data?.message || "Internal server error";
      throw new Error(`SERVER_ERROR: ${serverMessage}`);
    }

    if (
      error.message &&
      (error.message.includes("_REQUIRED") ||
        error.message.includes("INVALID_") ||
        error.message.includes("_MUST_BE_"))
    ) {
      throw error;
    }

    throw new Error("ERROR_createBroadcast");
  }
};
